import { LabelColor } from '../../components/label';

export const escapeButtonLabel = 'Back';

export const showTableTabCounts = true;

export type TableTabInfo = {
  value: string;
  label: string;
  color: LabelColor | undefined;
  count: number;
};

/** Tab count badge styles by tab index: 1st = primary (blue), 2nd = secondary, 3rd = info, 4th = warning, 5th = success */
export const TAB_BADGE_STYLES_BY_INDEX: {
  variant: 'default' | 'secondary' | 'info' | 'warning' | 'success';
  className: string;
}[] = [
  {
    variant: 'default',
    className:
      '!bg-primary/15 !text-primary dark:!text-primary-lighter dark:!bg-primary/25 !border-transparent !shadow-none'
  },
  {
    variant: 'secondary',
    className: '!bg-secondary/20 !text-secondary !border-transparent !shadow-none'
  },
  { variant: 'info', className: '!bg-info/15 !text-info !border-transparent !shadow-none' },
  {
    variant: 'warning',
    className: '!bg-warning/15 !text-warning !border-transparent !shadow-none'
  },
  { variant: 'success', className: '!bg-success/15 !text-success !border-transparent !shadow-none' }
];

/** Tab count label colors by tab index (for Label component with variant="soft") */
export const TAB_LABEL_COLORS_BY_INDEX: LabelColor[] = [
  'primary',
  'secondary',
  'info',
  'warning',
  'success'
];

//NOTE: Yup's email validator is broken. See: https://github.com/jquense/yup/issues/507
export const EMAIL_REGEX =
  /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
